import ApolloClient from 'apollo-client'
import { NormalizedCacheObject } from 'apollo-cache-inmemory'
import { errorPreventiveCacheRead } from '@sketch/modules-common'
import { GetInitialUserDocument, GetInitialUserQuery } from '@sketch/gql-types'

import { createOAuthFetcher as oldCreateOAuthFetcher } from './oauth-fetcher.old'
import { createOAuthFetcher as newCreateOAuthFetcher } from './oauth-fetcher'

type AuthorizationType = 'current-only' | 'current-and-secondary'
type FetchType = typeof window.fetch

export {
  checkIfTokenIsExpired,
  refreshToken,
  formatCredentials,
} from './refreshToken'

/**
 * checkMultipleAuthorizationsFF
 *
 * This function validates if the 'multiple-authorizations' FF exists
 * on the user feature-flags returns true if it exists.
 *
 */
const checkMultipleAuthorizationsFF = (
  client: ApolloClient<NormalizedCacheObject>
) => {
  const userData = errorPreventiveCacheRead<GetInitialUserQuery>(client, {
    query: GetInitialUserDocument,
  })

  return userData?.me.featureFlags?.includes('multiple-authorizations')
}

/**
 * createOAuthFetcher
 *
 * This function will serve as a switch between the two fetch methods (new/old)
 * and should be removed when the feature flag 'multiple-authorizations' is removed
 *
 */
const createOAuthFetcher = (
  getClient: () => ApolloClient<NormalizedCacheObject>,
  authorizationType: AuthorizationType = 'current-only'
) => {
  const oauthFetcher: FetchType = (...args) => {
    const isMultipleAuthorizationsFF = checkMultipleAuthorizationsFF(
      getClient()
    )

    if (isMultipleAuthorizationsFF) {
      return newCreateOAuthFetcher(getClient, authorizationType)(...args)
    }

    return oldCreateOAuthFetcher(getClient)(...args)
  }

  return oauthFetcher
}

export { createOAuthFetcher }
